module.exports = __webpack_public_path__ + "static/media/skintegrity.ee255573.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/labs/skintegrity.png
// module id = 136
// module chunks = 0